/* jshint esversion: 6 */
import { useContext, useEffect, useRef } from 'react';
import { MyContext } from '../../Context/MyProvider';
import { useNavigate } from 'react-router-dom';

const PaymentResponse = () => {
  const { setTransactionId } = useContext(MyContext);
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {

    if (processed.current) return;

    const url = new URL(window.location.href);
    const statusCode = url.searchParams.get('status_code');
    const orderId = url.searchParams.get('order_id');
    const transactionId = url.searchParams.get('transaction_id');
    const statusCode2 = url.searchParams.get('status');

    processed.current = true;

    if (statusCode === "200" || statusCode2 === "Completed") {
      handlePaymentSuccess(orderId, transactionId);
    } else {
      handlePaymentFailure();
    }

  }, []);

  const handlePaymentSuccess = (orderId, transactionId) => {
    const previousPage = sessionStorage.getItem("pages");
    sessionStorage.setItem("Paymentstatus", "PaymentDone");
    sessionStorage.setItem("PaymentTransactionId", transactionId || orderId || "");
    setTransactionId(transactionId || orderId);

    if (previousPage === "wallet") {
      navigate("/wallet");
    } else {
      navigate("/order-summery");
    }
  };

  // Handle failed payment
  const handlePaymentFailure = () => {
    sessionStorage.setItem("Paymentstatus", "paymentfaild");
    const previousPage = sessionStorage.getItem("pages");

    if (previousPage === "wallet") {
      navigate("/wallet");
    } else {
      navigate("/order-summery");
    }
  };

  return null;
};

export default PaymentResponse;